<template>
  <div
    class="sam-progress-indicator"
    :style="{ height: `${height}px` }"
    :class="progressBarClassObj"
    data-samora
  >
    <div class="sam-progress-indicator__bg"></div>
    <template v-if="indeterminate">
      <div class="sam-progress-indicator__indeterminateProgress increase"></div>
      <div class="sam-progress-indicator__indeterminateProgress decrease"></div>
    </template>
    <div
      v-else
      :style="{ width: `${progress}%` }"
      class="sam-progress-indicator__determinateProgress"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'SamProgressIndicator',
  props: {
    /**
     * If the Progress Bar type is Indeterminate or Determinate
     * @values true, false
     */
    indeterminate: {
      type: Boolean,
      required: false,
      default: true,
    },
    /**
     * The Progress Bar height in px
     */
    height: {
      type: Number,
      required: false,
      default: 4,
    },
    /**
     * If The Progress Bar is Determinate, this value is the progress in %
     */
    progress: {
      type: [Number, String],
      required: false,
      default: 0,
      validator(val) {
        return Number(val) >= 0 && Number(val) <= 100;
      },
    },
    /**
     * If The Progress Bar is on error state
     */
    error: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    progressBarClassObj() {
      return {
        'is-indeterminate': this.indeterminate,
        'is-success': this.progress === 100,
        'is-error': this.error,
      };
    },
  },
};
</script>

<style lang="scss" scoped>

.sam-progress-indicator {
  width: 100%;
  overflow-x: hidden;
  position: relative;
  border-radius: 2px;

  &.is-indeterminate {
    .sam-progress-indicator__bg {
      width: 150%;
    }
  }

  &__bg {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  &__determinateProgress {
    position: absolute;
    border-radius: inherit;
    height: 100%;
    transition: width $default-time $default-easing;
  }

  &__indeterminateProgress {
    position: absolute;
    border-radius: inherit;
    height: 100%;

    &.increase {
      animation: increase 2s infinite;
    }

    &.decrease {
      animation: decrease 2s 0.5s infinite;
    }
  }

  .sam-progress-indicator__bg {
    background-color: $neutral--30;
  }

  .sam-progress-indicator__determinateProgress {
    background-color: $informative--main;
  }

  .sam-progress-indicator__indeterminateProgress {
    background-color: $informative--main;
  }

  &.is-success {
    .sam-progress-indicator__determinateProgress {
      background-color: $success--main;
    }

    .sam-progress-indicator__indeterminateProgress {
      background-color: $success--main;
    }
  }

  &.is-error {
    .sam-progress-indicator__determinateProgress {
      background-color: $error--main;
    }

    .sam-progress-indicator__indeterminateProgress {
      background-color: $error--main;
    }
  }

  @keyframes increase {
    from {
      left: -5%;
      width: 5%;
    }
    to {
      left: 130%;
      width: 100%;
    }
  }
  @keyframes decrease {
    from {
      left: -80%;
      width: 80%;
    }
    to {
      left: 110%;
      width: 10%;
    }
  }
}
</style>
